import React, { Fragment } from 'react';
import moment from 'moment';
import useClipboard from 'react-use-clipboard';

import Alert from '../../../../../../../components/global/Alert';
import { DISCOUNT_MODE } from '../../../../../../../util/promo-codes';
import { formatPriceForDisplay } from '../../../../../../../util/format-money';
import Button from '../../../../../../../components/global/Button';
import CheckmarkIcon from '../../../../../../../components/icons/CheckmarkIcon';

const PrepaidPrintPackagesPurchaseContent = ({
  activePromoCode,
  onPurchase,
}) => {
  const [promoCodeCopied, setPromoCodeCopied] = useClipboard(
    activePromoCode?.code,
  );

  return (
    <Fragment>
      {/* TODO: The promo code should use a more targetted 
      approach to avoid exposing single use codes */}
      {activePromoCode && false && (
        <Alert type="info" className="prepaid-items-alert">
          {activePromoCode.expires_at && (
            <p className="text-sm text-primary text-uppercase mb-0 text-extra-bold">
              LIMITED TIME OFFER!
            </p>
          )}
          Use promo code &quot;
          <span className="text-primary text-extra-bold">
            {activePromoCode.code}
          </span>
          &quot;{' '}
          {activePromoCode.expires_at ? (
            <>
              and purchase your prints prior to{' '}
              <span className="text-primary text-extra-bold">
                {moment.utc(activePromoCode.expires_at).format('MMMM D, yyyy')}
              </span>{' '}
            </>
          ) : (
            ''
          )}
          to save{' '}
          <span className="text-primary text-extra-bold">
            {activePromoCode.discount.mode === DISCOUNT_MODE.PERCENTAGE
              ? `${activePromoCode.discount.value}%`
              : `$${formatPriceForDisplay(
                  activePromoCode.discount.value,
                  true,
                )}`}
          </span>
          !
          <Button
            pill
            btnOutline
            btnSize="sm"
            className="prepaid-print-packages-promo-code-copy"
            onClick={() => setPromoCodeCopied(true)}
          >
            {promoCodeCopied ? (
              <Fragment>
                <div>
                  <CheckmarkIcon size={12} color="white" />
                </div>{' '}
                Copied to clipboard
              </Fragment>
            ) : (
              'Copy promo code'
            )}
          </Button>
        </Alert>
      )}
      <Button onClick={onPurchase}>Purchase a print package</Button>
    </Fragment>
  );
};

export default PrepaidPrintPackagesPurchaseContent;
